import './index.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from './Modal';

class SecuritiesFirms extends Component {
  render() {
    const { isShowModal, modalRef } = this.props;
    return (
      isShowModal && (
        <div ref={modalRef} className="securities-firms-wrapper">
          <Modal />
        </div>
      )
    );
  }
}

SecuritiesFirms.defaultProps = {
  modalRef: React.createRef(),
};

const mapStateToProps = state => {
  return {
    isShowModal: state.isShowModal,
  };
};

export default connect(mapStateToProps)(SecuritiesFirms);
